/** The project list behind the scope picker: what the Memory Service knows for the tenant. */

import { request } from "./http";

export interface ProjectOption {
  project_id: string;
  /** Every memory under the project, whatever its status. */
  memory_count: number;
  repository_count: number;
  /** Attached repositories as `org/repo`. */
  repositories: string[];
  last_activity_at: string | null;
}

export interface ProjectListResponse {
  tenant_id: string;
  items: ProjectOption[];
  /** Set when the list could not be read, so the picker explains itself rather than looking empty. */
  detail: string | null;
}

export function fetchProjects(signal?: AbortSignal): Promise<ProjectListResponse> {
  return request<ProjectListResponse>("/api/projects", { ...(signal ? { signal } : {}) });
}

/**
 * The scope a runner falls back to when it cannot resolve its own (an MCP handshake before the
 * run has a repository, or a failed scope resolution). Real memory, but not a project anyone
 * chose -- the picker shows it last and says what it is.
 */
export const QUARANTINE_SUFFIX = "-unscoped-quarantine";

export function isQuarantine(projectId: string): boolean {
  return projectId.endsWith(QUARANTINE_SUFFIX);
}
